import _extends from "@babel/runtime/helpers/esm/extends";
import { ELanguage } from '../common';
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
import { EUserContactType } from './user';
export let EBroadcastStatus;
(function (EBroadcastStatus) {
  EBroadcastStatus["Pending"] = "pending";
  EBroadcastStatus["Scheduled"] = "scheduled";
  EBroadcastStatus["Uploading"] = "uploading";
  EBroadcastStatus["Accepted"] = "accepted";
  EBroadcastStatus["Declined"] = "declined";
  EBroadcastStatus["Expired"] = "expired";
  EBroadcastStatus["Failed"] = "failed";
  EBroadcastStatus["Skipped"] = "skipped";
  EBroadcastStatus["PendingCustomerSuccess"] = "pending-customer-success";
  EBroadcastStatus["DeclinedCustomerSuccess"] = "declined-customer-success";
})(EBroadcastStatus || (EBroadcastStatus = {}));
export let EBroadcastProcessingStatus;
(function (EBroadcastProcessingStatus) {
  EBroadcastProcessingStatus["UploadPending"] = "upload-pending";
  EBroadcastProcessingStatus["Uploaded"] = "uploaded";
  EBroadcastProcessingStatus["PatientsInProgress"] = "patients-in-progress";
  EBroadcastProcessingStatus["PatientsCreated"] = "patients-created";
  EBroadcastProcessingStatus["MessagesInProgress"] = "messages-in-progress";
  EBroadcastProcessingStatus["Success"] = "success";
  EBroadcastProcessingStatus["PartialFailure"] = "partial-failure";
  EBroadcastProcessingStatus["Failed"] = "failed";
})(EBroadcastProcessingStatus || (EBroadcastProcessingStatus = {}));
export let EBroadcastSelectMode;
(function (EBroadcastSelectMode) {
  EBroadcastSelectMode["All"] = "select-all";
  EBroadcastSelectMode["Individual"] = "select-individual";
})(EBroadcastSelectMode || (EBroadcastSelectMode = {}));
export const fieldsBroadcast = _extends({}, fieldsIBaseModel, {
  approvedBy: {
    type: 'ID',
    ref: EModel.User
  },
  createdFromBroadcast: {
    type: 'ID',
    ref: EModel.Broadcast
  },
  declinedBy: {
    type: 'ID',
    ref: EModel.User
  },
  declinedReason: {
    type: 'Text'
  },
  fileUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  filters: {
    type: 'Unknown'
  },
  isBeingProcessedInBatches: {
    type: 'Boolean'
  },
  isSftp: {
    type: 'Boolean'
  },
  message: {
    type: 'Text'
  },
  messagesCreated: {
    type: 'Number'
  },
  messagesSkipped: {
    type: 'Number'
  },
  patientMessageTemplate: {
    type: 'ID',
    ref: EModel.PatientMessageTemplate
  },
  patients: {
    type: 'ID',
    ref: EModel.Patient,
    array: true
  },
  patientsSkipped: {
    type: 'ID',
    ref: EModel.Patient,
    array: true
  },
  postApprovalStatus: {
    type: 'Option',
    values: EBroadcastStatus
  },
  processingStatus: {
    type: 'Option',
    values: EBroadcastProcessingStatus
  },
  secureChat: {
    type: 'Boolean'
  },
  selectMode: {
    type: 'Option',
    values: EBroadcastSelectMode
  },
  sendAt: {
    type: 'Date'
  },
  sentAt: {
    type: 'Date'
  },
  shouldReprocessFilters: {
    type: 'Boolean'
  },
  shouldUsePrimaryContactOnly: {
    type: 'Boolean'
  },
  shouldUseUploadedContacts: {
    type: 'Boolean'
  },
  status: {
    type: 'Option',
    values: EBroadcastStatus
  },
  statusReason: {
    type: 'Text'
  },
  statusUpdatedAt: {
    type: 'Date'
  },
  title: {
    type: 'Text'
  },
  totalPatients: {
    type: 'Number'
  },
  uiNumberOfPatients: {
    type: 'Number'
  },
  upload: {
    type: 'ID',
    ref: EModel.Upload
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  // Nested fields
  filterResults: {
    type: 'Object',
    array: true,
    values: {
      appointment: {
        type: 'ID',
        ref: EModel.Appointment
      },
      patient: {
        type: 'ID',
        ref: EModel.Patient
      },
      facility: {
        type: 'ID',
        ref: EModel.Facility
      }
    }
  },
  messageOverrides: {
    type: 'Object',
    array: true,
    values: {
      text: {
        type: 'Text'
      },
      language: {
        type: 'Option',
        values: [...Object.values(ELanguage), 'all']
      },
      channel: {
        type: 'Option',
        values: [...Object.values(EUserContactType), 'all']
      },
      subject: {
        type: 'Text'
      },
      patientMessageTemplate: {
        type: 'ID',
        ref: EModel.PatientMessageTemplate
      },
      secureChat: {
        type: 'Boolean'
      }
    }
  },
  stats: {
    type: 'Object',
    values: {
      createdMessages: {
        type: 'Number'
      },
      skippedMessages: {
        type: 'Number'
      }
    }
  }
});